export const AiChatSelectionMode = {
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE',
};
export const AiChatInputRequestStatus = {
    PENDING: 'PENDING',
    ANSWERED: 'ANSWERED',
    CANCELLED: 'CANCELLED',
};
//# sourceMappingURL=ai-chat-decisions.js.map